import ThemeGenerator from "../../../../src/pages/theme-generator/Generator.jsx";
import * as React from 'react';
export default {
  ThemeGenerator,
  React
};